import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';
import { bindActionCreators } from 'redux';
import * as Actions from '../store/actions';
import { connect } from 'react-redux';
import DraggableUnscheduledLesson from './DraggableUnscheduledLesson';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

class UnscheduledCourseOrder extends Component {

    constructor(props) {
        super(props);
    }

    pushCard = (event) => {
        // console.log(event)
        // this.props.prepareDisplayOrders()
        this.props.pushUnscheduledLesson(event)
    }

    render() {
        const { canDrop, isOver, connectDropTarget } = this.props;
        let orderedList = this.props.selectedLessons.sort((a, b) => a.DisplayOrder - b.DisplayOrder)
        const isActive = canDrop && isOver;
        const style = {
            width: '100%',
            minHeight: '100%',
            border: '2px dotted black'
        };

        const backgroundColor = isActive ? 'lightgreen' : '#FFF';

        const testItems = orderedList.map((lesson, i) => {
            return (
                <ListItem key={i}>
                    <ListItemIcon>
                        <b>{i + 1}</b>
                    </ListItemIcon>
                    <ListItemText>
                        <DraggableUnscheduledLesson
                            key={lesson.lesson_id}
                            index={i}
                            lesson={lesson}
                            handleDelete={this.props.handleUnscheduledLessonDelete}
                            moveCard={this.props.moveUnscheduledLesson}
                        />
                    </ListItemText>
                </ListItem>
            )
        })

        const testList =
            <List dense={true}>
               {testItems}
            </List>

        return connectDropTarget(
            <div style={{ ...style, backgroundColor: backgroundColor }}>
                {testList}
            </div>
        );
    }
}

const cardTarget = {
    drop(props, monitor, component) {
        // console.log(props)
        // console.log(monitor)
        // console.log(component)
        const sourceObj = monitor.getItem();
        if (sourceObj.card) {
            component.pushCard(sourceObj)
        }
        else {
            component.pushCard(sourceObj)
        }


        return { target: 'this is a target' }
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        pushUnscheduledLesson: Actions.pushUnscheduledLesson
    }, dispatch);
}

function mapStateToProps({ lessonApp }) {
    return {
    }
}

export default DropTarget("item", cardTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
}))(UnscheduledCourseOrder);



// WEBPACK FOOTER //
// src/main/content/course/builderComponents/UnscheduledCourseOrder.js